import type { NumberSpeller } from './types'

const ONES = ['பூஜ்ஜியம்', 'ஒன்று', 'இரண்டு', 'மூன்று', 'நான்கு', 'ஐந்து', 'ஆறு', 'ஏழு', 'எட்டு', 'ஒன்பது', 'பத்து',
  'பதினொன்று', 'பன்னிரண்டு', 'பதிமூன்று', 'பதினான்கு', 'பதினைந்து', 'பதினாறு', 'பதினேழு', 'பதினெட்டு', 'பத்தொன்பது']
const TENS = ['', '', 'இருபது', 'முப்பது', 'நாற்பது', 'ஐம்பது', 'அறுபது', 'எழுபது', 'எண்பது', 'தொண்ணூறு']
// Combining form of the tens when a unit follows: 26 = இருபத்தி ஆறு.
const TENS_JOIN = ['', '', 'இருபத்தி', 'முப்பத்தி', 'நாற்பத்தி', 'ஐம்பத்தி', 'அறுபத்தி', 'எழுபத்தி', 'எண்பத்தி', 'தொண்ணூற்றி']
const HUNDREDS = ['', 'நூறு', 'இருநூறு', 'முந்நூறு', 'நானூறு', 'ஐந்நூறு', 'அறுநூறு', 'எழுநூறு', 'எண்ணூறு', 'தொள்ளாயிரம்']
const HUNDREDS_JOIN = ['', 'நூற்று', 'இருநூற்று', 'முந்நூற்று', 'நானூற்று', 'ஐந்நூற்று', 'அறுநூற்று', 'எழுநூற்று', 'எண்ணூற்று',
  'தொள்ளாயிரத்து']

function below100(n: number): string {
  if (n < 20) return ONES[n]
  const t = Math.floor(n / 10)
  return n % 10 ? `${TENS_JOIN[t]} ${ONES[n % 10]}` : TENS[t]
}

function below1000(n: number): string {
  const h = Math.floor(n / 100)
  const r = n % 100
  if (!h) return below100(r)
  return r ? `${HUNDREDS_JOIN[h]} ${below100(r)}` : HUNDREDS[h]
}

/** Adjectival "one" before லட்சம்/கோடி: ஒன்று → ஒரு, பதினொன்று → பதினொரு. */
function adjective(words: string): string {
  return words.endsWith('ஒன்று') || words.endsWith('ொன்று') ? `${words.slice(0, -4)}ரு` : words
}

/** q × 1000, fused: இரண்டாயிரம், பதினாறாயிரம், எண்பத்தி நான்காயிரம், இருபத்தி ஓராயிரம். */
function thousands(q: number): string {
  if (q === 1) return 'ஆயிரம்'
  const words = below100(q)
  if (words.endsWith('ஒன்று')) return `${words.slice(0, -5)}ஓராயிரம்`
  if (words.endsWith('ொன்று')) return `${words.slice(0, -5)}ோராயிரம்`
  return `${words.slice(0, -1)}ாயிரம்` // every word below 100 ends in the vowel sign ு
}

function spell(n: number): string {
  if (n === 0) return ONES[0]
  const parts: string[] = []
  const crore = Math.floor(n / 10_000_000)
  const lakh = Math.floor((n % 10_000_000) / 100_000)
  const thousand = Math.floor((n % 100_000) / 1000)
  const rest = n % 1000
  if (crore) parts.push(`${crore === 1 ? 'ஒரு' : adjective(spell(crore))} ${n % 10_000_000 ? 'கோடியே' : 'கோடி'}`)
  if (lakh) parts.push(`${lakh === 1 ? 'ஒரு' : adjective(below100(lakh))} ${n % 100_000 ? 'லட்சத்து' : 'லட்சம்'}`)
  if (thousand) {
    const word = thousands(thousand)
    parts.push(rest ? word.replace(/ம்$/, 'த்து') : word)
  }
  if (rest) parts.push(below1000(rest))
  return parts.join(' ')
}

export const ta: NumberSpeller = {
  spell,
  year: spell,
  rupees: 'ரூபாய்'
}
